__webpack_require__.p = "/ui/core/front/dist/";